import { GET_ALL_TERRITORIES_PAGINATION } from '../constants';

import { getStrapiCountries } from './getStrapiCountries';
import { getStrapiCities } from './getStrapiCities';

import type { Locales } from '@monoimin/sb-types';

export const getTerritoriesData = async (locale: Locales) => {
  return Promise.all([
    getStrapiCountries({
      pagination: GET_ALL_TERRITORIES_PAGINATION,
    }),
    getStrapiCities({
      populate: {
        country: {
          fields: ['slug'],
        },
      },
      pagination: GET_ALL_TERRITORIES_PAGINATION,
      locale: locale,
    }),
  ])
    .then((res) => {
      const [countriesRes, citiesRes] = res;

      return { countries: countriesRes.countries, cities: citiesRes.cities };
    })
    .catch(() => {
      return { countries: [], cities: [] };
    });
};

export default getTerritoriesData;
